/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

const kycScreenMapping = {
  SELFIE: 'SELFIE',
  FACE_MATCH: 'FACE_MATCH',
  E_SIGN: 'E_SIGN',
  DDPI: 'DDPI',
  SPECIMEN_SIGN: 'SPECIMEN_SIGN',
  DIGILOCKER: 'DIGILOCKER',
  PAN_STRICT_VALIDATION: 'PAN_STRICT_VALIDATION',
  NOMINEE: 'NOMINEE',
  PENNY_DROP: 'PENNY_DROP',
  PERSONAL_DETAILS: 'PERSONAL_DETAILS',
  COMPLETE: 'COMPLETE',
  INCOME_DECLARATION: 'INCOME_DECLARATION',
  CHOICE: 'CHOICE',
  UPLOAD_PAN: 'UPLOAD_PAN',
  CHECK_ARN: 'CHECK_ARN',
  META_FORM: 'META_FORM',
  AGREEMENT: 'AGREEMENT',
  GST_DETAILS: 'GST_DETAILS',
  BANK_PROOF: 'BANK_PROOF',
  ADDRESS: 'ADDRESS',
  ADDRESS_PROOF: 'ADDRESS_PROOF',
  OPS_EVALUATION: 'OPS_EVALUATION',
  PASSPORT: 'PASSPORT',
  TRADING_PREFERENCES: 'TRADING_PREFERENCES',
  UPLOAD_ARN: 'UPLOAD_ARN',
  UPLOAD_EUIN: 'UPLOAD_EUIN',
  ARN_CHOICE: 'ARN_CHOICE',
  IDS_CHOICE: 'IDS_CHOICE',
  UPLOAD_IDS: 'UPLOAD_IDS',
  FATCA: 'FATCA',
  RPD: 'RPD',
  PAN_ANALYSIS: 'PAN_ANALYSIS',
  AA: 'AA',
  MINOR_DETAILS: 'MINOR_DETAILS',
  RELATIONSHIP_PROOF: 'RELATIONSHIP_PROOF',
};

const kycAllStepsMapping = {
  CVL: 'CVL',
  CKYC: 'CKYC',
  DIGILOCKER_STRICT_PULL: 'DIGILOCKER_STRICT_PULL',
  GEN_FORMS: 'GEN_FORMS',
  UPLOAD_FORMS: 'UPLOAD_FORMS',
  ...kycScreenMapping,
};

const kycScreenDisplayNameMapping = {
  [kycAllStepsMapping.SELFIE]: 'Selfie',
  [kycAllStepsMapping.CKYC]: 'CKYC Verification',
  [kycAllStepsMapping.CVL]: 'Analyze PAN',
  [kycAllStepsMapping.FACE_MATCH]: 'Face Verification',
  [kycAllStepsMapping.E_SIGN]: 'E-Sign',
  [kycAllStepsMapping.DDPI]: 'Demat Debit and Pledge Instruction',
  [kycAllStepsMapping.SPECIMEN_SIGN]: 'Specimen Signature',
  [kycAllStepsMapping.DIGILOCKER]: 'DigiLocker',
  [kycAllStepsMapping.DIGILOCKER_STRICT_PULL]: 'DigiLocker Document Fetch',
  [kycAllStepsMapping.PAN_STRICT_VALIDATION]: 'PAN Validation',
  [kycAllStepsMapping.NOMINEE]: 'Nominee Details',
  [kycAllStepsMapping.PENNY_DROP]: 'Bank Verification',
  [kycAllStepsMapping.PERSONAL_DETAILS]: 'Personal Details',
  [kycAllStepsMapping.COMPLETE]: 'Completion',
  [kycAllStepsMapping.INCOME_DECLARATION]: 'Income Declaration without Bank OTP',
  [kycAllStepsMapping.CHOICE]: 'Selection',
  [kycAllStepsMapping.UPLOAD_PAN]: 'Upload PAN Card',
  [kycAllStepsMapping.CHECK_ARN]: 'Check ARN',
  [kycAllStepsMapping.META_FORM]: 'Additional Information',
  [kycAllStepsMapping.AGREEMENT]: 'Terms & Agreement',
  [kycAllStepsMapping.GST_DETAILS]: 'GST Information',
  [kycAllStepsMapping.BANK_PROOF]: 'Bank Proof',
  [kycAllStepsMapping.ADDRESS]: 'Address',
  [kycAllStepsMapping.ADDRESS_PROOF]: 'Address Verification',
  [kycAllStepsMapping.OPS_EVALUATION]: 'Evaluation',
  [kycAllStepsMapping.PASSPORT]: 'Passport Details',
  [kycAllStepsMapping.TRADING_PREFERENCES]: 'Trading Preferences',
  [kycAllStepsMapping.UPLOAD_ARN]: 'ARN Certificate',
  [kycAllStepsMapping.UPLOAD_EUIN]: 'EUIN Certificate',
  [kycAllStepsMapping.ARN_CHOICE]: 'ARN Selection',
  [kycAllStepsMapping.IDS_CHOICE]: 'ID Selection',
  [kycAllStepsMapping.UPLOAD_IDS]: 'Upload Identification Documents',
  [kycAllStepsMapping.FATCA]: 'FATCA Declaration',
  [kycAllStepsMapping.GEN_FORMS]: 'Generate Forms',
  [kycAllStepsMapping.UPLOAD_FORMS]: 'Upload Forms',
  [kycAllStepsMapping.RPD]: 'Bank Account Verification Via UPI',
  [kycAllStepsMapping.PAN_ANALYSIS]: 'Verifying PAN',
  [kycAllStepsMapping.AA]: 'Income Verification via Bank OTP',
  [kycAllStepsMapping.MINOR_DETAILS]: 'Details of the Minor',
  [kycAllStepsMapping.RELATIONSHIP_PROOF]: 'Relationship Details',
};

const kycScreenDescriptionMapping = {
  [kycAllStepsMapping.SELFIE]: 'Take a clear selfie for verification',
  [kycAllStepsMapping.CKYC]: 'Verify your Central KYC details',
  [kycAllStepsMapping.CVL]: 'Fetch your current KYC status',
  [kycAllStepsMapping.FACE_MATCH]: 'Verify your face with ID photo',
  [kycAllStepsMapping.E_SIGN]: 'Sign documents electronically',
  [kycAllStepsMapping.DDPI]: 'Authorize demat transactions',
  [kycAllStepsMapping.SPECIMEN_SIGN]: 'Provide your signature sample',
  [kycAllStepsMapping.DIGILOCKER]: 'Fetch your documents from DigiLocker',
  [kycAllStepsMapping.DIGILOCKER_STRICT_PULL]: 'Fetch your verified documents from DigiLocker',
  [kycAllStepsMapping.PAN_STRICT_VALIDATION]: 'Verify your PAN details',
  [kycAllStepsMapping.NOMINEE]: 'Add your nominee information',
  [kycAllStepsMapping.PENNY_DROP]: 'Verify your bank account',
  [kycAllStepsMapping.PERSONAL_DETAILS]: 'Update your personal information',
  [kycAllStepsMapping.COMPLETE]: 'Complete your KYC process',
  [kycAllStepsMapping.INCOME_DECLARATION]: 'Declare your income sources',
  [kycAllStepsMapping.CHOICE]: 'Choose your verification method',
  [kycAllStepsMapping.UPLOAD_PAN]: 'Upload your PAN card image',
  [kycAllStepsMapping.CHECK_ARN]: 'Verify ARN registration number',
  [kycAllStepsMapping.META_FORM]: 'Complete additional details',
  [kycAllStepsMapping.AGREEMENT]: 'Accept terms and agreements',
  [kycAllStepsMapping.GST_DETAILS]: 'Provide GST registration info',
  [kycAllStepsMapping.BANK_PROOF]: 'Upload bank account proof',
  [kycAllStepsMapping.ADDRESS]: 'Provide your current address',
  [kycAllStepsMapping.ADDRESS_PROOF]: 'Verify your address details',
  [kycAllStepsMapping.OPS_EVALUATION]: 'Our team is currently verifying your information',
  [kycAllStepsMapping.PASSPORT]: 'Add your passport information',
  [kycAllStepsMapping.TRADING_PREFERENCES]: 'Set your trading preferences',
  [kycAllStepsMapping.UPLOAD_ARN]: 'Upload ARN certificate',
  [kycAllStepsMapping.UPLOAD_EUIN]: 'Upload EUIN certificate',
  [kycAllStepsMapping.ARN_CHOICE]: 'Select your ARN preference',
  [kycAllStepsMapping.IDS_CHOICE]: 'Choose ID type for verification',
  [kycAllStepsMapping.UPLOAD_IDS]: 'Upload your identification documents',
  [kycAllStepsMapping.FATCA]: 'Complete FATCA declaration',
  [kycAllStepsMapping.GEN_FORMS]: 'Generate necessary documentation for processing',
  [kycAllStepsMapping.UPLOAD_FORMS]: 'Upload completed forms for verification',
  [kycAllStepsMapping.RPD]: 'Quick UPI bank verification',
  [kycAllStepsMapping.PAN_ANALYSIS]: 'Verifying PAN',
  [kycAllStepsMapping.AA]: 'Verify your bank account details securely',
  [kycAllStepsMapping.MINOR_DETAILS]: 'Enter details of the minor',
  [kycAllStepsMapping.RELATIONSHIP_PROOF]: 'Define relationship with the minor',
};

// ALL_FI reuses BrokingFNOFlowService.perform_aa() (same step key), but it's not an
// income-verification step there - it's the net-worth calculator's account connection step.
const kycScreenDisplayNameOverridesAllFi = {
  [kycAllStepsMapping.AA]: 'Account Aggregator',
};

const kycScreenDescriptionOverridesAllFi = {
  [kycAllStepsMapping.AA]: 'Securely connect your accounts to calculate your net worth',
};

const KycFlowMapping = {
  MF_NRI: 'MF_NRI',
  PARTNER: 'PARTNER',
};

export default kycScreenMapping;
export {
  KycFlowMapping,
  kycScreenDisplayNameMapping,
  kycScreenDescriptionMapping,
  kycScreenDisplayNameOverridesAllFi,
  kycScreenDescriptionOverridesAllFi,
};
